<template>
    <svg
        width="24"
        height="24"
        viewBox="2 2 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.747 15.0127C20.5279 15.1332 20.8833 16.1164 20.2929 16.707L18.9999 18V19C18.9999 19.5176 18.6065 19.9437 18.1024 19.9951L17.9999 20H9.9999C8.96425 20 8.11291 19.2128 8.01064 18.2041L7.9999 18V17C7.9999 15.8954 8.89533 15 9.9999 15H19.5858L19.747 15.0127ZM9.9999 16.5C9.72376 16.5 9.4999 16.7239 9.4999 17V18C9.4999 18.2761 9.72376 18.5 9.9999 18.5H17.4999V17.3789L18.3788 16.5H9.9999Z"
            fill="currentColor"
        />
        <path d="M12.4999 9.75C12.9141 9.75005 13.2499 10.0858 13.2499 10.5C13.2499 10.9142 12.9141 11.2499 12.4999 11.25H8.4999C8.08569 11.25 7.7499 10.9142 7.7499 10.5C7.7499 10.0858 8.08569 9.75 8.4999 9.75H12.4999Z" fill="currentColor" />
        <path d="M15.4999 6.75C15.9141 6.75005 16.2499 7.08582 16.2499 7.5C16.2499 7.91418 15.9141 8.24995 15.4999 8.25H8.4999C8.08569 8.25 7.7499 7.91421 7.7499 7.5C7.7499 7.08579 8.08569 6.75 8.4999 6.75H15.4999Z" fill="currentColor" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.9999 4C18.1044 4.00005 18.9999 4.89546 18.9999 6V12C18.9999 13.0356 18.2126 13.8869 17.204 13.9893L16.9999 14H6.9999L6.7958 13.9893C5.85425 13.8938 5.1061 13.1456 5.01064 12.2041L4.9999 12V7L3.70693 5.70703C3.07711 5.07709 3.52319 4.00012 4.41396 4H16.9999ZM6.4999 6.37891V12C6.4999 12.2761 6.72376 12.5 6.9999 12.5H16.9999C17.276 12.4999 17.4999 12.2761 17.4999 12V6C17.4999 5.72389 17.276 5.50005 16.9999 5.5H5.62099L6.4999 6.37891Z"
            fill="currentColor"
        />
    </svg>
</template>
